import { FC } from 'react';
import {
  FormControl,
  FormLabel,
  Input,
  Stack,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Modal,
  Text,
  Textarea,
} from '@chakra-ui/react';
import { useDeleteStore } from '../../hooks';

type Props = ReturnType<typeof useDeleteStore>;

export const ApiKeyTemplateDeleteModalView: FC<Props> = ({
  values,
  isOpenModal,
  onCloseModal,
  onDeleteApiKeyTemplate,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="2xl"
    blockScrollOnMount
  >
    <ModalOverlay />
    <ModalContent>
      <ModalHeader p="40px">APIキーテンプレートの削除</ModalHeader>
      <ModalCloseButton />
      <ModalBody px="40px">
        <Stack spacing="6" direction="column">
          <FormControl>
            <FormLabel>テンプレート名</FormLabel>
            <Input
              type="text"
              value={values.name}
              width="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
          </FormControl>
          <FormControl>
            <FormLabel>テンプレート名</FormLabel>
            <Textarea
              value={values.template}
              rows={8}
              variant="flushed"
              isReadOnly
            />
          </FormControl>
        </Stack>
        <Text mt="60px" align="center" fontWeight="bold">
          上記のAPIキーテンプレート情報を削除しますか？
        </Text>
      </ModalBody>
      <ModalFooter gap="16px" justifyContent="center" p="40px">
        <Button
          w="140px"
          colorScheme="blackAlpha"
          variant="outline"
          onClick={onCloseModal}
        >
          キャンセル
        </Button>
        <Button colorScheme="red" onClick={onDeleteApiKeyTemplate} w="140px">
          削除
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
